/**
 * Logos de marcas pelo logo.dev (mesma chave pública do site, feita para ir na URL).
 */
const LOGO_DEV_TOKEN = 'pk_NDJhFMOfRNaMDok_40C9zQ';

export const logoDev = (domain: string, size = 64) =>
  `https://img.logo.dev/${domain}?token=${LOGO_DEV_TOKEN}&size=${size}&format=png&retina=true`;

export type Brand = 'facebook' | 'instagram' | 'whatsapp' | 'meta' | 'chatwoot' | 'perfex' | 'asaas' | 'stripe';

const BRANDS: Record<Brand, { label: string; domain: string }> = {
  facebook: { label: 'Facebook', domain: 'facebook.com' },
  instagram: { label: 'Instagram', domain: 'instagram.com' },
  whatsapp: { label: 'WhatsApp', domain: 'whatsapp.com' },
  meta: { label: 'Meta', domain: 'meta.com' },
  chatwoot: { label: 'Chatwoot', domain: 'chatwoot.com' },
  perfex: { label: 'Perfex CRM', domain: 'perfexcrm.com' },
  asaas: { label: 'Asaas', domain: 'asaas.com' },
  stripe: { label: 'Stripe', domain: 'stripe.com' },
};

export function brandLogo(brand: Brand, size = 64): { src: string; label: string } {
  const b = BRANDS[brand];
  return { src: logoDev(b.domain, size), label: b.label };
}

/** Canais oficiais de conexão */
export type ConnectionProvider = 'META' | 'INSTAGRAM';

/** Marca do provedor de uma conexão (WhatsAppSession.provider ou INSTAGRAM) */
export function providerBrand(provider: ConnectionProvider | string | null | undefined): Brand {
  return provider === 'INSTAGRAM' ? 'instagram' : 'meta';
}
